import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'

import { navLinks } from '@/constants/site'

// The stage wordmark, promoted into a real header. Type treatment, position,
// and opacities are the section's (12px / 0.32em over 9px / 0.30em), so the
// deck page looks untouched. The bar itself is pointer-transparent — only the
// links take the cursor, so dragging the deck through it still works.

export const Navbar: FC = (): ReactNode => {
    const { pathname } = useRouter()

    return (
        <>
            <div aria-hidden className='riffle-nav-scrim' />

            <header
                className='riffle-nav pointer-events-none fixed inset-x-0 top-0 z-40 flex items-start justify-between px-5 pt-5 sm:px-8 sm:pt-7'
            >
                <Link
                    href='/'
                    aria-label='Riffle — the 2026 library'
                    className='riffle-word pointer-events-auto block'
                >
                    <span
                        className='font-mono block uppercase'
                        style={{ fontSize: 12, fontWeight: 500, letterSpacing: '0.32em', opacity: 0.9 }}
                    >
                        Riffle
                    </span>

                    <span
                        className='riffle-word-sub font-mono block uppercase'
                        style={{ fontSize: 9, letterSpacing: '0.3em', opacity: 0.5, marginTop: 4 }}
                    >
                        ♪ The 2026 Library
                    </span>
                </Link>

                <nav
                    aria-label='Primary'
                    className='pointer-events-auto flex items-start gap-5 sm:gap-9'
                    style={{ marginTop: 2 }}
                >
                    {navLinks.map((link) => {
                        const active =
                            link.href === '/' ? pathname === '/' : pathname.startsWith(link.href)

                        return (
                            <Link
                                key={link.href}
                                href={link.href}
                                data-active={active}
                                aria-current={active ? 'page' : undefined}
                                className='riffle-nav-link font-mono uppercase'
                                style={{ fontSize: 11, letterSpacing: '0.28em' }}
                            >
                                {link.label}

                                <span aria-hidden className='riffle-nav-rule' />
                            </Link>
                        )
                    })}
                </nav>
            </header>
        </>
    )
}
